import { useEffect, useState } from 'react';
import {
    AlertSection,
    Alerts,
} from '../../../../../shared/types/legalProceedings/alerts';
import {
    asyncCreateAlert,
    asyncGetAlert,
    asyncUpdateAlert,
} from '../../../../../services/alerts.service';
import { FormikProps } from 'formik';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { useNavigate, useParams } from 'react-router-dom';
import { ALERTS_DETAIL, ALERTS } from '../../../../../routes/paths';
import { cleanObj } from '../../../../../shared/utils/objects';

export const useAlertsForm = () => {
    const navigate = useNavigate();
    const { idAlert } = useParams();
    const [alert, setAlert] = useState<Alerts>();
    const [loading, setLoading] = useState(false);
    const [formikProcess, setFormikProcess] = useState<FormikProps<Alerts>>();

    const [formikAlertSection, setFormikAlertSection] =
        useState<FormikProps<AlertSection>>();

    const isValidForm = formikProcess?.isValid && formikAlertSection?.isValid;

    const handleSubmit = async () => {
        await formikProcess?.submitForm();
        await formikAlertSection?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Alerts = {
            ...formikProcess?.values,
            alertSection: cleanObj(formikAlertSection?.values),
        };

        let res: { items?: Alerts; message?: string } | undefined;

        try {
            if (alert && alert.id) res = await asyncUpdateAlert(alert.id, data);
            else res = await asyncCreateAlert(data);
        } catch (error) {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo actualizar o crear la alerta. Por favor, asegúrate de 
                        diligenciar los datos correctamente
                            o que no exista previamente
                     e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }
        if (res?.items) {
            ToastSwal.fire({
                text: `¡Felicidades! La alerta se ${
                    alert && alert.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${ALERTS_DETAIL}/${res?.items?.id}`);
        } else {
            if (res?.message === 'ALERT-FAIL-DUPLICATED-RULE-NUMBER') {
                ToastSwal.fire({
                    text: 'El número de la alerta ya está asignado, intenta crearla nuevamente.',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            } else {
                ToastSwal.fire({
                    text: `Lo sentimos, no se pudo ${
                        alert && alert.id ? 'actualizar' : 'crear'
                    } la alerta. Por favor, asegúrate de ${
                        alert && alert.id
                            ? 'diligenciar los datos correctamente'
                            : 'que no exista previamente'
                    } e intenta nuevamente más tarde.`,
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            }
        }

        setLoading(false);
    };

    const handleBack = () => {
        navigate(ALERTS);
    };

    const handleClean = () => {
        formikProcess?.resetForm();
        formikAlertSection?.resetForm();
    };

    useEffect(() => {
        if (Boolean(idAlert?.trim())) {
            setLoading(true);
            asyncGetAlert(idAlert?.trim())
                .then((alert) => {
                    if (!alert || !alert.id) navigate(ALERTS);
                    setAlert(alert);
                })
                .finally(() => setLoading(false));
        }
    }, [idAlert]);

    return {
        alert,
        loading,
        isValidForm,
        handleSubmit,
        handleClean,
        handleBack,
        setFormikProcess,
        setFormikAlertSection,
        formikProcess,
        formikAlertSection,
    };
};
